import { CssProps, HStack } from '@nettbureau/vibrant-ui';
import { ReactNode, forwardRef } from 'react';
import { GridItemProps, VirtuosoGrid } from 'react-virtuoso';

interface VirtualizedGridProps<T> {
  items: T[];
  itemRenderer: (item: T, index: number) => ReactNode;
  query: string;
  setQuery(q: string): void;
}

const List = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <HStack
      align="stretch"
      justify="center"
      gap={4}
      wrap={true}
      ref={ref}
      {...props}
    />
  );
});

List.displayName = 'List';

type ItemProps = GridItemProps & CssProps;

const GridItem = (props: ItemProps) => {
  /** @ts-expect-error dont know why this fails */
  return <HStack className={props.className} {...props} />;
};

export function VirtualizedGrid<T>({
  items,
  query,
  setQuery,
  itemRenderer,
}: VirtualizedGridProps<T>) {
  return (
    <VirtuosoGrid
      data={items}
      useWindowScroll
      context={{ numResults: items.length, setQuery, query }}
      components={{
        Item: (props) => {
          return <GridItem {...props} />;
        },
        List,
      }}
      itemContent={(index, item: T) => {
        return itemRenderer(item, index);
      }}
    />
  );
}
